/// <reference path="input.ts" />
/// <reference path="button.ts" />
/// <reference path="animation.ts" />

/**
 * <dl>
 * <dt>属性</dt>
 * <dd>multiple: 複数選択を可能とする場合に設定します</dd>
 * <dd>closest: ドラッグ＆ドロップ対応にする先祖エレメントのタグ（省略時:自身のタグ）</dd>
 * </dl>
 * その他の属性はKoyoriInputに依存します。
 */
class KoyoriInputFile extends KoyoriInput {

	static get observedAttributes() {
		return ['label', 'message'].concat(this.inputAttributes);
	}

	static get inputAttributes() {
		return ['value', 'name', 'disabled', 'multiple', 'accept'];
	}

	/** ドロップエリア */
	private dropArea: HTMLElement;

	constructor() {
		super();
	}

	connectedCallback(): void {
		super.connectedCallback();

		if (this.querySelector('.koy-input-file-droparea') == null) {
			this.dropArea = document.createElement('div');
			this.dropArea.classList.add('koy-input-file-droparea');
			this.querySelector(".koy-input-wrapper").appendChild(this.dropArea);

			this.inputElement.classList.add('koy-hide');

			this.inputElement.addEventListener('change', event => {
				this.updateFiles((<HTMLInputElement>event.target).files, false);
			});

			let eventElement: HTMLElement = null;
			if (this.getAttribute('closest') != null) {
				eventElement = <HTMLElement>this.closest(this.getAttribute('closest'));
			}
			if (eventElement == null) {
				eventElement = this.dropArea;
			}

			eventElement.addEventListener('dragenter', event => {
				this.dropArea.classList.add('koy-input-file-drag');
				event.preventDefault();
				event.stopPropagation();
			});

			eventElement.addEventListener('dragover', event => {
				event.dataTransfer.dropEffect = 'copy';
				event.preventDefault();
				event.stopPropagation();
			});

			eventElement.addEventListener('dragleave', event => {
				this.dropArea.classList.remove('koy-input-file-drag');
				event.preventDefault();
				event.stopPropagation();
			});

			eventElement.addEventListener('drop', event => {
				this.updateFiles(event.dataTransfer.files, true);
				this.dropArea.classList.remove('koy-input-file-drag');
				event.dataTransfer.dropEffect = 'copy';
				event.preventDefault();
				event.stopPropagation();
			});

			this.updateFiles(null, false);
		}
	}

	/**
	 * @return 変更イベントを取得する属性のリスト
	 */
	protected getObservedAttributes(): string[] {
		return KoyoriInputFile.observedAttributes;
	}

	/**
	 * @return inputタグに設定する属性のリスト
	 */
	protected getInputAttributes(): string[] {
		return KoyoriInputFile.inputAttributes;
	}

	get value(): string {
		let values = this.values;
		if (values.length == 0) {
			return null;
		}
		return values[0];
	}

	set value(data: string) {
	}

	get values(): string[] {
		let values: string[] = [];
		KoyoriElement.querySelectorAll(this, '.koy-input-file-tn input').forEach(input => {
			values.push((<HTMLInputElement>input).value);
		});
		return values;
	}
	
	/**
	 * 初期状態に戻します。
	 * TODO: value属性がある場合に対応する
	 */
	reset(): void {
		(<HTMLInputElement>this.inputElement).value = '';
		this.dropArea.innerHTML = '';
	}

	/**
	 * @return inputタグのtype属性の値
	 */
	protected getInputType(): string {
		return 'file';
	}

	/**
	 * ファイルが選択された場合に呼び出されます。
	 * 
	 * @param files
	 * @param append すでに登録されている内容に追加する場合はtrue
	 */
	private updateFiles(files: FileList, append: boolean): void {
		if (this.getAttribute('disabled') != null) {
			return;
		}

		if (append == false || this.getAttribute('multiple') == null) {
			this.dropArea.innerHTML = '';
		}

		if (files != null) {
			Array.prototype.forEach.call(files, (file: File, index: number) => {
				if (index > 0 && this.getAttribute('multiple') == null) {
					return;
				};
				let tn = document.createElement('span');
				tn.classList.add('koy-input-file-tn');
				let reader = new FileReader();
				if (file.type.indexOf('image/') == 0) {
					reader.addEventListener('load', () => {
						let img = document.createElement('img');
						img.src = reader.result as string;
						tn.appendChild(img);
					});
				} else {
					reader.addEventListener('load', () => {
						let icon = document.createElement('span');
						icon.classList.add('koy-input-file-tn-icon');
						tn.appendChild(icon);
					});
				}
				reader.addEventListener('load', () => {
					let input = document.createElement('input');
					input.name = this.getAttribute('name');
					input.value = reader.result as string;
					input.type = 'hidden';
					tn.appendChild(input);
				});
				reader.readAsDataURL(file);
				{
					let buttion = new KoyoriButton();
					buttion.classList.add('koy-input-file-tn-delete', 'koy-fab');
					buttion.addEventListener('click', (event) => {
						KoyoriAnimation.fadeOut(tn);
						setTimeout(() => {
							this.dropArea.removeChild(tn);
						}, 300);
						event.preventDefault();
					});
					tn.appendChild(buttion);
				}
				{
					let name = document.createElement('div');
					name.classList.add('koy-input-file-tn-name');
					name.textContent = file.name;
					tn.appendChild(name);
				}
				this.dropArea.appendChild(tn);
			});
		}

		(<HTMLInputElement>this.inputElement).value = '';
	}
}
window.customElements.define('koy-input-file', KoyoriInputFile);
